import { useEffect, useMemo, useState } from 'react'
import { byText, hexToAdjustedHSL } from '../../helpers'
import { LabelSelectLabel } from './label-select'
import * as Token from '@fold-dev/design/tokens-es6'
import { classNames, getForegroundColor } from '@fold-dev/core'
export type LabelsLabel = {} & LabelSelectLabel

export type LabelProps = {
    disabled?: boolean
    onClick: (e) => void
} & LabelsLabel

export const Label = (props: LabelProps) => {
    const { onClick, disabled, id, color, text } = props
    const { isDouble, words } = useMemo(() => {
        return {
            isDouble: text.includes(':'),
            words: text.split(':'),
        }
    }, [text])
    const doubleStyle: any = useMemo(
        () => ({
            color: 'var(--f-color-base-50)',
            backgroundColor: color,
        }),
        [text, disabled, color, isDouble]
    )
    const style: any = useMemo(
        () => ({
            color,
            border: `1px solid rgb(from ${color} r g b / 10%)`,
            pointerEvents: disabled ? 'none' : undefined,
            backgroundColor: `rgb(from ${color} r g b / 15%)`,
        }),
        [text, disabled, color, isDouble]
    )
    const className = classNames({
        'f-label': true,
        'f-buttonize': true,
        'f-row': true,
        'f-ellipsis': !isDouble,
        'is-double': isDouble,
    })

    return (
        <span
            style={style}
            tabIndex={0}
            className={className}
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onClick(e)
            }}>
            {isDouble && (
                <>
                    <span
                        className="f-label__first f-row"
                        style={doubleStyle}>
                        {words[0]}
                    </span>
                    <span className="f-label__second f-row">{words[1]}</span>
                </>
            )}

            {!isDouble && <span>{text}</span>}
        </span>
    )
}

export type LabelsProps = {
    shorten?: boolean
    disabled?: boolean
    labels: LabelsLabel[]
    onClick: (e) => void
}

export const Labels = ({ shorten, labels, disabled, onClick }: LabelsProps) => {
    const [sortedLabels, setSortedLabels] = useState([])
    const [more, setMore] = useState(0)

    useEffect(() => {
        const sortedLabels = labels.sort(byText)
        setSortedLabels(labels)
        //if (shorten) setMore(sortedLabels.length > 5 ? sortedLabels.length - 5 : 0)
    }, [labels, labels.length, shorten])

    if (labels.length == 0) return null

    return (
        <>
            {/*  {!!more && (
                <Label
                    disabled={disabled}
                    id=""
                    icon={undefined}
                    text={`+ ${more}`}
                    color={Token.ColorBase500}
                    onClick={onClick}
                />
            )} */}
            {labels
                //.filter((_, index: number) => shorten ? index < 5 : true)
                .sort(byText)
                .map((label: any) => (
                    <Label
                        disabled={disabled}
                        key={label.id}
                        id={label.id}
                        icon={label.icon}
                        text={label.text}
                        color={label.color}
                        onClick={onClick}
                    />
                ))}
        </>
    )
}
